import { Link } from "react-router-dom";

const CheckoutAuthStrip = ({ returnUrl = "/market/checkout", className = "" }) => (
  <p className={`checkout-auth-strip${className ? ` ${className}` : ""}`}>
    Returning customer?{" "}
    <Link to={`/Login?returnUrl=${encodeURIComponent(returnUrl)}`}>Sign in</Link>
  </p>
);

export default CheckoutAuthStrip;
